import Alert from 'client/components/aria/Alert/Alert';
import { FormattedMessage, useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';
import { useNavigate } from 'react-router';
import { ENQUIRIES_PAGE } from 'client/utils/routes/routeConstants';
import styles from './EnquiryAlertError.module.scss';

const EnquiryAlertError = (props) => {
    const intl = useIntl();
    const navigate = useNavigate();

    const handleConfirmation = () => {
        navigate(ENQUIRIES_PAGE);
    };

    return (
        <>
            <div className="govuk-grid-row">
                <Alert
                    title={ intl.formatMessage({ id: 'enquiryAlerts.error.title' })}
                    variant="info"
                    { ...props }
                >
                    <FormattedMessage id="enquiryAlerts.error"/>
                </Alert>
            </div>
            <div className="govuk-grid-row">
                <div className="govuk-grid-column-full">
                    <ButtonGroup className={styles.buttons}>
                        <Button
                            data-testid="enquiryAlerts.button.ok"
                            variant="success"
                            onPress={handleConfirmation}
                        >
                            { intl.formatMessage({ id: 'enquiryAlerts.button' })}
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        </>
    );
};

EnquiryAlertError.propTypes = {
    ...defaultAriaProps
};

export default EnquiryAlertError;
